import { ENDPOINT } from 'api/endPoints/getProjectScoreCardsSummary';

import { NoPermissionMessagePortfolioPage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    IPortfolioProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM, large } from 'components/Dashboards/Reporting/reportingConfig';

export const projectScorecards: IHashmapItemWithCustomProps<IPortfolioProps> = {
    NoPermissionMessage: NoPermissionMessagePortfolioPage,
    titleWithoutProjectAndContract: 'Portfolio',
    permission: 'PortfolioPage',
    globalFiltersConfig: [{ key: 'programTags', name: 'programTags', defaultValue: [] }],

    title: 'Portfolio Scorecard',
    id: 'score-card',
    componentKey: 'projectScorecards',
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: large,
    },
    endpoint: ENDPOINT,
};
